import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-export-confirm',
  templateUrl: './export-confirm.component.html',
  styleUrls: ['./export-confirm.component.scss']
})

export class ExportConfirmComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<ExportConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  close(): void {
    this.dialog.close();
  }

}
